import { render, staticRenderFns } from "./CampaignItemEnglish.vue?vue&type=template&id=7d16dd4a&scoped=true&"
import script from "./CampaignItemEnglish.vue?vue&type=script&lang=js&"
export * from "./CampaignItemEnglish.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItemEnglish.vue?vue&type=style&index=0&id=7d16dd4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d16dd4a",
  null
  
)

export default component.exports